import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { ReactNode } from 'react';

export const NewRequestTableButtons = ({
    onDeleteButtonClick,
    isEdit,
    toggleEdit,
    formToSubmitId,
    onRestoreButtonClick,
    leadingAction,
}: {
    onDeleteButtonClick?: () => void;
    isEdit: boolean;
    toggleEdit: () => void;
    formToSubmitId: string;
    onRestoreButtonClick?: () => void;
    leadingAction?: ReactNode;
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    return (
        <td className='w-100 d-flex justify-content-end align-items-center p-0 pt-1 pb-1 pe-2 gap-2'>
            {leadingAction}
            {isEdit ? (
                <>
                    <Button form={formToSubmitId} type='submit' className='px-3 py-1'>
                        {t('save')}
                    </Button>
                    <Button type='button' onClick={toggleEdit} className='px-3 py-1 z-5 btn-close-white'>
                        {t('cancel')}
                    </Button>
                </>
            ) : onRestoreButtonClick ? (
                <>
                    <Button onClick={onRestoreButtonClick} className='px-3 py-1 btn-success'>
                        {t('restore')}
                    </Button>
                    <Button className='px-3 py-1 z-5' onClick={toggleEdit}>
                        {t('edit')}
                    </Button>
                </>
            ) : (
                <>
                    {onDeleteButtonClick && (
                        <Button onClick={onDeleteButtonClick} className='px-3 py-1 btn-danger'>
                            {t('setInactive')}
                        </Button>
                    )}
                    <Button className='px-3 py-1 z-5' onClick={toggleEdit}>
                        {t('edit')}
                    </Button>
                </>
            )}
        </td>
    );
};
